import React from 'react'
import { Dashboard } from '../modules/dashboard'

export const DashboardOverviewPage = () => {
    return (
        <Dashboard />
    )
}
